<template>

    <form ref="certificacoesregrasisencao-form-edit" novalidate>
        <div class="row">
            <div class="form-group col-md-6">
                <label for="Exame">Selecione o exame ao qual a regra se aplica:</label>
                <select v-select="{ dataitem: 'Interesse', default: 'Selecione' }" v-model="model.interesseId" class="form-control" name="exameId"></select>
            </div>
            <div class="form-group col-md-6">
                <label for="certificacoesRegrasIsencaoNome">Nome</label>
                <input type="text" class="form-control" name="certificacoesRegrasIsencaoNome" placeholder="Nome da Regra" maxlength="150" v-model="model.nome" />
            </div>
            <div class="form-group col-md-6">
                <label for="dataInicioVigencia">Data Início Vigência</label>
                <input type="text" v-datepicker class="form-control" autocomplete="off" name="dataInicioVigencia" v-model="model.dataInicioVigencia" />
            </div>
            <div class="form-group col-md-6">
                <label for="dataTerminoVicengia">Data Término Vigência</label>
                <input type="text" v-datepicker class="form-control" autocomplete="off" name="dataTerminoVigencia" v-model="model.dataTerminoVigencia" />
            </div>
            <br />
            <p class="font-weight-bold ml-3">Informe abaixo os critérios para isenção:</p>
            <br /><br />
        </div>
        <div class="row">
            <div class="form-group col-md-11">
                <div class="pull-right" style="color:red; font-size:small" id="errors"></div>
            </div>
        </div>
        <div class="row">
            <section class="col col-3">
                <label class="label">Critérios</label>
                <label class="select">
                    <select id="criterios" name="criterios" style="width:100%">
                        <option value="Selecione">Selecione</option>
                        <option value="DataTerminoTurma">DataTerminoTurma</option>
                        <option value="DataInicioTurma">DataInicioTurma</option>
                        <option value="Modalidade">Modalidade</option>
                        <option value="StatusChaveAcesso">StatusChaveAcesso</option>
                        <option value="ChaveAtivada">ChaveAtivada</option>
                        <option value="EstagioId">EstagioId</option>
                        <option value="IdiomaId">IdiomaId</option>
                        <option value="StatusRematriculaId">StatusRematriculaId</option>
                        <option value="ProximoEstagioId">ProximoEstagioId</option>
                        <option value="StatusProximoDocumentoEstagioId">StatusProximoDocumentoEstagioId</option>
                        <option value="QuantidadeEstagiosCursadosNuevo">QuantidadeEstagiosCursadosNuevo</option>
                        <option value="StatusEntregaMaterialDidaticolId">StatusEntregaMaterialDidaticolId</option>
                        <option value="ValidaTurmaNoventaDias">ValidaTurmaNoventaDias</option>
                    </select>
                    <i></i>
                </label>
            </section>
            <section class="col col-3">
                <label class="label">Operador</label>
                <label class="select">
                    <select id="operador" name="operador" style="width:100%">
                        <option value="Selecione">Selecione</option>
                        <option value="=">=</option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                        <option value="<>"><></option>
                        <option value="IN">IN</option>
                    </select>
                    <i></i>
                </label>
            </section>
            <div class="form-group col-md-4" style="width:250px;">
                <label for="valor">Valor</label>
                <input type="text" class="form-control" name="valor" id="valor" placeholder="Valor" />
            </div>
            <div class="form-inline mt-3">

                <button type="button" class="btn btn-success btn-sm pull-right" @click="add()">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="table-responsive standard-table header-cinza">
            <table>
                <thead>
                    <tr>
                        <th>CRITÉRIO<i></i></th>
                        <th style="text-align:center">OPERADOR</th>
                        <th style="text-align:center">VALOR</th>
                        <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in result.items" class="animated fadeIn">
                        <td>{{ item.criterio}}</td>
                        <td style="text-align:center">{{ item.operador}}</td>
                        <td style="text-align:center">{{ item.valor}}</td>
                        <td class="text-center">
                            <button type="button" class="btn btn-danger btn-sm" @click="remove(item)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row">
            <div class="form-group col-md-6 pull-right">
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>
        </div>
        <div>
            <button type="button" class="btn btn-default" @click="onBack()">
                <span>Cancelar</span>
            </button>
            <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
                <span>Salvar</span>
            </button>
        </div>
    </form>
</template>
<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "certificacoesregrasisencao-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({
            criterio: {
                id: 0,
                criterio: null,
                operador: null,
                valor: null,
                certificacoesRegrasIsencaoId: 0,
            },

            model: {
                collectionCertificacoesRegrasIsencaoCriterio: []
            },
            filter: {
                pageSize: 50,
                pageIndex: 1,
                isPagination: true,
            },
            result: {
                total: 0,
                items: []
            },
            form: "certificacoesregrasisencao-form-edit",
            resources: {
                filter: 'certificacoesregrasisencaocriterio',
                edit: 'certificacoesregrasisencao',
                crudCriterio: 'certificacoesregrasisencaocriterio',
            },
        }),
        methods: {
            fechar() {
                this.criterioDelete = null;
            },
            onBack: function () {
                this.$emit('on-back')
            },
            add() {
                var validaNumero = /^[0-9]*$/;                
                var patternData = /^\d{4}[\-\/\s]?((((0[13578])|(1[02]))[\-\/\s]?(([0-2][0-9])|(3[01])))|(((0[469])|(11))[\-\/\s]?(([0-2][0-9])|(30)))|(02[\-\/\s]?[0-2][0-9]))$/;
                if (this.criterio.id === 0) {
                    this.criterio.criterio = document.getElementById('criterios').value
                    this.criterio.operador = document.getElementById('operador').value
                    this.criterio.valor = document.getElementById('valor').value
                    if (this.criterio.criterio == "Selecione" || this.criterio.operador == "Selecione" || this.criterio.valor == "") {
                        document.getElementById('errors').innerHTML = "*Preencha Critério, Operador e Valor*";
                        return false;
                    }
                    if (this.criterio.criterio == "DataInicioTurma" || this.criterio.criterio == "DataTerminoTurma") {
                        if (!patternData.test(this.criterio.valor)) {
                            document.getElementById('errors').innerHTML = "*Preencha o valor com uma data no formato yyyy/mm/dd*";
                            return false;
                        }
                    }
                    if (this.criterio.operador == "IN") {
                        var temVirgula = this.criterio.valor.indexOf(",") > -1;
                        var comecaComVirgula = this.criterio.valor.substring(0, 1).indexOf(",") > -1;
                        var terminaComVirgula = this.criterio.valor.trim().slice(-1).substring(0, 1).indexOf(",") > -1;
                        if (!temVirgula || comecaComVirgula || terminaComVirgula) {
                            document.getElementById('errors').innerHTML = "*Valor incorreto.*";
                            return false;
                        }

                    }
                    if (this.criterio.criterio != "DataInicioTurma" && this.criterio.criterio != "DataTerminoTurma" && this.criterio.criterio != "Selecione" && this.criterio.operador != "IN") {
                        if (!validaNumero.test(this.criterio.valor)) {
                            document.getElementById('errors').innerHTML = "*Valor aceita apenas números*";
                            return false;
                        }
                    }
                    this.result.items.push(this.criterio)
                } else {
                    this.list[this.index] = this.criterio
                }
                this.limparCamposCriterio();
                this.criterio = { id: 0, operador: null, valor: null }
            },
            limparCamposCriterio() {
                document.getElementById('criterios').value = "Selecione";
                document.getElementById('operador').value = "Selecione";
                document.getElementById('valor').value = "";
            },

            remove(item) {
                const idx = this.result.items.indexOf(item)
                this.result.items.splice(idx, 1)
            },
            executeEdit: function (model) {
                if (model.interesseId == "")
                    model.interesseId = 0;
                    
                this.model.collectionCertificacoesRegrasIsencaoCriterio = this.result.items
                new Api('certificacoesregrasisencao/atualizar').put(model).then(data => {

                    this.$emit('on-saved', data)
                    this.defaultSuccessResult("Edição realizada com sucesso");
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

        },

        mounted() {
            new Api(this.resources.edit).get({ certificacoesRegrasIsencaoId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model = {};
            },
                err => {
                    this.defaultErrorResult(err);
                })
            new Api(this.resources.crudCriterio).get({ certificacoesRegrasIsencaoId: this.id }).then(dataCriterios => {
                if (dataCriterios.dataList.length > 0) {
                    this.result.items = dataCriterios.dataList;
                }
            },
                err => {
                    this.defaultErrorResult(err);
                })
        }
    };
</script>